import React, { useMemo } from 'react';
import { useFormEditorContext } from '@/components/Questionnaire/questionnaireEditor/FormEditor/FormEditorContext';
import Expression from '@/helpers/expressions/ThisExpression';
import ExpressionEditor from '@/components/ExpressionEditor';
import { Questionnaire } from '@/typings/Questionnaire';

type listFilterProps = {
  disabled?: boolean;
  listFilterExpression?: Expression;
  setListFilterExpression?: Parameters<typeof ExpressionEditor>[0]['onChange'];
};

const ListFilter: React.FC<listFilterProps> = ({
  listFilterExpression,
  setListFilterExpression,
}) => {
  const { formData } = useFormEditorContext();

  const fieldsInfo = useMemo(() => {

    const info: Record<
      string,
      Pick<Questionnaire.FieldCommon, 'key' | 'label' | 'type' | 'options'>
    > = {};

    formData.sections.forEach((section) => {
      section.fields.forEach((field) => {
        info[field.key] = {
          key: field.key,
          label: field.label || field.key,
          options: field.options,
          type: field.type,
        };
      });
    });

    return info;
  }, [formData.sections]);

  return (
    <>
      <ExpressionEditor
        expression={listFilterExpression ?? null}
        onChange={setListFilterExpression}
        fieldsInfo={fieldsInfo} />
    </>
  );

};

export default ListFilter;
